import { useCallback } from 'react';
import HomeNav from '@/pages/home/components/HomeNav';
import Hero from '@/pages/home/components/Hero';
import QuickFacts from '@/pages/home/components/QuickFacts';
import OriginalAndRemake from '@/pages/home/components/OriginalAndRemake';
import CompareTabs from '@/pages/home/components/CompareTabs';
import LeadLadies from '@/pages/home/components/LeadLadies';
import BehindScenes from '@/pages/home/components/BehindScenes';
import ClassicScenes from '@/pages/home/components/ClassicScenes';
import Reviews from '@/pages/home/components/Reviews';
import BoxOffice from '@/pages/home/components/BoxOffice';
import FaqSection from '@/pages/home/components/FaqSection';
import DiscussionSection from '@/pages/home/components/DiscussionSection';
import SiteFooter from '@/pages/home/components/SiteFooter';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function Home() {
  useScrollReveal();

  const handleJump = useCallback((id: string) => {
    const target = document.getElementById(id);
    if (target) {
      const top = target.getBoundingClientRect().top + window.scrollY - 72;
      window.scrollTo({ top, behavior: 'smooth' });
    }
  }, []);

  return (
    <div className="w-full min-h-screen bg-background-50">
      <HomeNav />
      <main>
        <Hero onJump={handleJump} />
        <QuickFacts />
        <OriginalAndRemake />
        <CompareTabs />
        <LeadLadies />
        <BehindScenes />
        <ClassicScenes />
        <Reviews />
        <BoxOffice />
        <FaqSection />
        <DiscussionSection />
      </main>
      <SiteFooter onJump={handleJump} />
    </div>
  );
}